<template>
  <b-modal id="modal-close-cash" hide-header-close hide-footer no-close-on-esc no-close-on-backdrop ok-title="Tutup"
    size="lg" class="custom__modal" @show="updateFormattedDate">
    <template #modal-header>
      <div
        v-if="showBackButton"
        class="text-primary fw-bold-600 pt-25 cursor-pointer"
        @click="goBack(backTarget)"
      >
        <feather-icon size="16" class="text-primary fw-bold-800" icon="ArrowLeftIcon" />
        Kembali
      </div>

      <div :class="['mx-auto', showBackButton ? 'pr-4' : '']">
        <div class="size20 fw-bold-600 text-dark">{{ headerTitle }}</div>
      </div>
    </template>
    <div class="p-2" v-if="isAdditionalCash">
      <div class="d-flex align-items-center justify-content-between" style="margin-bottom: 12px">
        <h5 class="size14 fw-bold-700 mb-0">Cash Tambahan</h5>
        <h5 class="size14 fw-bold-700 mb-0">Deskripsi</h5>
      </div>
      <div class="d-flex align-items-center justify-content-between mb-2" style="margin-bottom: 6px"
        v-for="(item, index) in detailResultList.additional_list" :key="index">
        <h5 class="size14 fw-bold-600 mb-0">
          {{ formatToRupiah(item.amount) }}
        </h5>
        <h5 class="size14 fw-bold-600 mb-0">
          {{ item.description || "-" }}
        </h5>
      </div>
      <b-form-group class="custom__form--input">
        <label for="v-cash-tambahan">Total Cash Tambahan</label>
        <b-input-group prepend="Rp">
          <b-form-input id="v-cash-tambahan" v-model="detailResultList.additional_cash" class="custom__input"
            type="text" disabled />
        </b-input-group>
      </b-form-group>
    </div>
    <div class="p-2" v-if="isCashChange">
      <div class="d-flex align-items-center justify-content-between" style="margin-bottom: 12px">
        <h5 class="size14 fw-bold-700 mb-0">No Invoice</h5>
        <h5 class="size14 fw-bold-700 mb-0">Kembalian</h5>
      </div>
      <div class="d-flex align-items-center justify-content-between" style="margin-bottom: 6px"
        v-for="item in detailResultList.cash_change_list" :key="item.uuid">
        <router-link class="text-primary" :to="'invoice/' + item.uuid" target="_blank">
          {{ item.invoice_number }}
        </router-link>
        <h5 class="size14 fw-bold-600 mb-0">
          {{ formatToRupiah(item.cash_change) }}
        </h5>
      </div>
    </div>
    <div class="p-2" v-if="isReturSelling">
      <retur-selling :items="detailResultList.order_returned_list" />
    </div>
    <div class="p-2" v-if="isReturPurchasing">
      <retur-purchasing :items="detailResultList.incoming_stock_returned_list" />
    </div>
    <div class="p-2" v-if="isPiutangPayments">
      <piutang-payments :items="detailResultList.piutang_payment_list" />
    </div>
    <div class="p-2" v-if="isUtangPayments">
      <utang-payments :items="detailResultList.utang_payment_list" />
    </div>
    <div class="p-2" v-if="isTopupDeposit">
      <topup-deposit :items="detailResultList.topup_deposit_payment_list" />
    </div>
    <div class="p-2" v-if="isWithdrawDeposit">
      <withdraw-deposit :items="detailResultList.withdraw_deposit_payment_list" />
    </div>
    <div class="p-2" v-if="isCanceledOrder">
      <table class="table">
        <thead>
          <tr>
            <th scope="col">No. Invoice</th>
            <th scope="col">Kuantiti</th>
            <th scope="col">Total</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="canceledOrder in detailResultList.order_canceled_list" :key="canceledOrder.uuid">
            <td>
              <router-link class="text-primary" :to="'invoice/' + canceledOrder.uuid" target="_blank">
                {{ canceledOrder.invoice_number }}
              </router-link>
            </td>
            <td>{{ canceledOrder.qty }}</td>
            <td>{{ formatToRupiah(canceledOrder.total) }}</td>
          </tr>
        </tbody>
        <tbody v-if="detailResultList.order_canceled_list && detailResultList.order_canceled_list.length === 0">
          <tr>
            <td
              colspan="4"
              class="text-center"
            >
              Data kosong.
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <b-row class="px-2 pt-2" v-if="shouldShowDefaultView">
      <b-col cols="12" md="6">
        <b-form-group class="custom__form--input">
          <label for="v-name">Nama User</label>
          <b-form-input id="v-name" :value="detailResultList.operator_name" class="custom__input" type="text" placeholder="Nama" disabled />
        </b-form-group>
      </b-col>
      <b-col cols="12" md="6">
        <b-form-group class="custom__form--input">
          <label for="v-date">Waktu Tutup</label>
          <b-form-input id="v-date" v-model="date" class="custom__input" type="text" placeholder="Tanggal" disabled />
        </b-form-group>
      </b-col>
    </b-row>
    
    <cash-in-cash-out v-if="shouldShowDefaultView" :cashOut="cashOut" :formPayload="formPayload" :cashIn="cashIn" :detailResultList="detailResultList" :openCashModal="openCashModal" :goToSellingDetail="goToSellingDetail" :goToCashOutDetail="goToCashOutDetail" :goToStockLocationSku="goToStockLocationSku" :goToStockSupplier="goToStockSupplier" />
    
    <div class="button__group" v-if="shouldShowDefaultView">
      <b-button class="button__cancel fw-bold-700 size13" @click="closeModal()">
        Batal
      </b-button>
      <b-button :disabled="(detailResultList.operator_name !== user.name && (userRole.length == 1 && userRole.includes('Owner'))) || isLoading" class="button__save fw-bold-700 size13" @click="closeItem()">
        <div class="d-flex align-items-center justify-content-center" style="gap: 5px">
          <b-spinner label="Loading..." v-if="isLoading" />
          <span>Tutup</span>
        </div>
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import {
  BButton,
  BModal,
  BRow,
  BCol,
  BContainer,
  BTable,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BInputGroup,
  BSpinner,
} from "bootstrap-vue";
import {
  checkPermission,
  successNotification,
  errorNotification,
  preformatFloat,
} from "@/auth/utils";

import moment from "moment";
import "moment/locale/id";
import ReturSelling from './ReturSelling.vue';
import ReturPurchasing from './ReturPurchasing.vue';
import PiutangPayments from './PiutangPayments.vue';
import UtangPayments from './UtangPayments.vue';
import TopupDeposit from "./TopupDeposit.vue";
import WithdrawDeposit from "./WithdrawDeposit.vue";
import CashInCashOut from './CashInCashOut.vue';


export default {
  components: {
    BButton,
    BModal,
    BRow,
    BCol,
    BContainer,
    BTable,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BFormCheckbox,
    ReturSelling,
    ReturPurchasing,
    PiutangPayments,
    UtangPayments,
    TopupDeposit,
    WithdrawDeposit,
    BSpinner,
    CashInCashOut
  },
  setup() {
   return {
      checkPermission,
      successNotification,
      errorNotification,
      preformatFloat,
    };
  },
  computed: {
    showBackButton() {
      return this.isAdditionalCash || this.isReturList || this.isCashChange || this.isCanceledOrder || this.isReturSelling || this.isReturPurchasing || this.isPiutangPayments || this.isUtangPayments || this.isTopupDeposit || this.isWithdrawDeposit;
    },
    backTarget() {
      if (this.isAdditionalCash) return 'additional';
      if (this.isReturList) return 'retur';
      if (this.isCanceledOrder) return 'canceledOrder';
      if (this.isReturSelling) return 'retur_selling';
      if (this.isReturPurchasing) return 'retur_purchasing';
      if (this.isPiutangPayments) return 'piutang_payments';
      if (this.isUtangPayments) return 'utang_payments';
      if (this.isTopupDeposit) return 'topup_deposit';
      if (this.isWithdrawDeposit) return 'withdraw_deposit';
      return 'cash';
    },
    headerTitle() {
      if (this.isAdditionalCash) return 'Detail Cash Tambahan';
      if (this.isCashChange) return 'Kembalian';
      if (this.isReturList) return 'List Jumlah Retur';
      if (this.isReturSelling) return 'List Jumlah Retur Penjualan';
      if (this.isCanceledOrder) return 'List Transaksi Dibatalkan';
      if (this.isReturPurchasing) return 'List Jumlah Retur Pembelian';
      if (this.isPiutangPayments) return 'List Pembayaran Piutang';
      if (this.isUtangPayments) return 'List Pembayaran Utang';
      if (this.isTopupDeposit) return 'List Topup Deposit';
      if (this.isWithdrawDeposit) return 'List Withdraw Deposit';
      return 'Kas Harian';
    },
    shouldShowDefaultView() {
      return !this.isAdditionalCash && !this.isCashChange && !this.isReturList && !this.isCanceledOrder && !this.isReturSelling && !this.isReturPurchasing && !this.isPiutangPayments && !this.isUtangPayments && !this.isTopupDeposit && !this.isWithdrawDeposit;
    },
  },
  data() {
    const newData = new Date();
    const momentDate = moment(newData);
    const days = [
      "Minggu",
      "Senin",
      "Selasa",
      "Rabu",
      "Kamis",
      "Jumat",
      "Sabtu",
    ];
    const months = [
      "Januari",
      "Februari",
      "Maret",
      "April",
      "Mei",
      "Juni",
      "Juli",
      "Agustus",
      "September",
      "Oktober",
      "November",
      "Desember",
    ];
    const formattedDate = `${days[momentDate.day()]}, ${momentDate.format(
      "DD"
    )} ${months[momentDate.month()]} ${momentDate.format("YYYY HH:mm")}`;
    const userRole = JSON.parse(localStorage.getItem('userRole'))
    return {
      userRole,
      moment,
      isLoading: false,
      user: JSON.parse(localStorage.getItem("userData")),
      date: formattedDate,
      formPayload: {
        closing_cash: 0,
      },
      detailResultList: Object,
      isAdditionalCash: false,
      isReturList: false,
      isCashChange: false,
      isCanceledOrder: false,
      isReturSelling: false,
      isReturPurchasing: false,
      isPiutangPayments: false,
      isUtangPayments: false,
      isTopupDeposit: false,
      isWithdrawDeposit: false,
      cashIn: Object,
      cashOut: Object,
    };
  },
  props: {
    getData: {
      type: Function,
    },
    detailResult: {
      type: Object,
    },
  },
  watch: {
    detailResult(result) {
      this.detailResultList = result;
      this.cashIn = result?.cash_details?.cash_in;
      this.cashOut = result?.cash_details?.cash_out;
      this.setRupiah()
    },
  },
  methods: {
    setRupiah() {
      const format = (value) => this.formatRupiah((value ?? 0).toString().replace('-'), '');
      const formatV2 = (value) => this.formatToRupiah((value ??0).toString().replace('-'),'');

      // Format main cash fields
      this.detailResultList.opening_cash = format(this.detailResultList?.opening_cash);
      this.detailResultList.additional_cash = format(this.detailResultList?.additional_cash);
      this.formPayload.closing_cash = this.formatToRupiah(this.detailResultList?.cash_summary);

      if (this.cashIn && this.cashOut) {
        const cashInFields = [
          'order_success_amount',
          'piutang_amount',
          'topup_deposit_amount',
          'purchase_return_amount',
        ];

        const cashOutFields = [
          'order_canceled_amount',
          'incoming_stock_supplier_amount',
          'incoming_stock_warehouse_amount',
          'utang_amount',
          'withdraw_deposit_amount',
          'other_payment_amount',
          'cash_change',
          'order_return_amount'
        ]

        cashInFields.forEach(key => {
          if (key in this.cashIn) {
            this.cashIn[key] = formatV2(this.cashIn[key]);
          }
        });

        cashOutFields.forEach(key => {
          if (key in this.cashOut) {
            this.cashOut[key] = formatV2(this.cashOut[key]);
          }
        });
      }
    },
    formatRupiah(angka, prefix) {
      let number_string = angka.replace(/[^,\d-]/g, "").toString();
      let isNegative = number_string.startsWith("-");
      if (isNegative) {
        number_string = number_string.substring(1);
      }
      const split = number_string.split(",");
      const sisa = split[0].length % 3;
      let rupiah = split[0].substr(0, sisa);
      const ribuan = split[0].substr(sisa).match(/\d{3}/gi);

      if (ribuan) {
        const separator = sisa ? "." : "";
        rupiah += separator + ribuan.join(".");
      }
      rupiah = split[1] != undefined ? `${rupiah},${split[1]}` : rupiah;
      return (
        (isNegative ? "-" : "") + (prefix == undefined ? rupiah : rupiah || "")
      );
    },

    formatToRupiah(amount) {
      const formatter = new Intl.NumberFormat("id-ID", {
        style: "currency",
        currency: "IDR",
        minimumFractionDigits: 0,
        maximumFractionDigits: 3,
      });
      return formatter.format(amount).replace("Rp", "").trim();
    },
    closeModal() {
      this.cleanUpForm();
      this.$bvModal.hide("modal-close-cash");
    },
    cleanUpForm() {
      this.formPayload.closing_cash = 0;
    },
    preparePayload() {
      const form = new FormData();
      // eslint-disable-next-line no-restricted-syntax
      for (const key in this.formPayload) {
        // eslint-disable-next-line no-prototype-builtins
        if (
          this.formPayload.hasOwnProperty(key) &&
          this.formPayload[key] != null
        ) {
          if (key === "closing_cash") {
            // eslint-disable-next-line radix
            form.append(
              key,
              this.detailResultList?.cash_summary
            );
          } else {
            form.append(key, this.formPayload[key]);
          }
        }
      }
      return form;
    },
    closeItem() {
      const form = this.preparePayload();
      this.isLoading = true;
      this.$store
        .dispatch("pettyCash/postClose", {
          query: "",
          payload: form,
          uuid: this.detailResultList.uuid,
        })
        .then(() => {
          this.getData();
          successNotification(this, "Success", "Kas Harian berhasil ditutup");
          this.cleanUpForm();
          this.$bvModal.hide("modal-close-cash");
          this.isLoading = false;
        })
        .catch((error) => {
          if (error.response.data.meta.validations) {
            this.validations = error.response.data.meta.validations;
          }
          this.isLoading = false;
        });
    },
    updateFormattedDate() {      
      const newDate = new Date();
      const momentDate = moment(newDate);

      const days = [
        "Minggu",
        "Senin",
        "Selasa",
        "Rabu",
        "Kamis",
        "Jumat",
        "Sabtu",
      ];
      const months = [
        "Januari",
        "Februari",
        "Maret",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Agustus",
        "September",
        "Oktober",
        "November",
        "Desember",
      ];
      this.date = `${days[momentDate.day()]}, ${momentDate.format("DD")} ${months[momentDate.month()]} ${momentDate.format("YYYY HH:mm")}`;
    },
    goToCashInDetail() {
      const openingTime = this.detailResultList.opening_time;
      moment.locale("id");
      const date = moment(openingTime);
      const formattedDate = date.format("YYYY-MM-DD");
      const routeParams = {
        name: "transaction.index",
        query: { date: formattedDate },
      };
      const routePath = this.$router.resolve(routeParams).href;
      window.open(routePath, "_blank");
    },
    goToCashOutDetail() {
      const openingTime = this.detailResultList.opening_time;
      moment.locale("id");
      const date = moment(openingTime);
      const formattedDate = date.format("YYYY-MM-DD");
      const routeParams = {
        name: "payout.index",
        query: { date: formattedDate, payment_method: 'cash' },
      };
      const routePath = this.$router.resolve(routeParams).href;
      window.open(routePath, "_blank");
    },
    openCashModal(stateKey) {
      this.$bvModal.hide("modal-close-cash");
      // Reset all view flags
      this.isAdditionalCash = false;
      this.isReturList = false;
      this.isCanceledOrder = false;
      this.isCashChange = false;
      this.isReturSelling = false;
      this.isReturPurchasing = false;
      this.isPiutangPayments = false;
      this.isUtangPayments = false;
      this.isTopupDeposit = false;
      this.isWithdrawDeposit = false;

      // Set only the selected one to true
      if (stateKey && this.hasOwnProperty(stateKey)) {
        this[stateKey] = true;
      }

      this.$bvModal.show("modal-close-cash");
    },
    goBack(target) {
      this.$bvModal.hide("modal-close-cash");

      const resetMap = {
        additional: 'isAdditionalCash',
        retur: 'isReturList',
        retur_selling: 'isReturSelling',
        canceledOrder: 'isCanceledOrder',
        cash: 'isCashChange',
        retur_purchasing: 'isReturPurchasing',
        piutang_payments: 'isPiutangPayments',
        utang_payments: 'isUtangPayments',
        topup_deposit: 'isTopupDeposit',
        withdraw_deposit: 'isWithdrawDeposit',
      };

      const stateKey = resetMap[target];

      if (stateKey) {
        this[stateKey] = false;
      }

      this.$bvModal.show("modal-close-cash");
    },
    navigateWithCashAndDate(routeName, type = null) {
      const openingTime = this.detailResultList.opening_time;
      const uuid = this.detailResultList.uuid;

      // Ensure the date is in ISO format
      const formattedDate = moment(openingTime, moment.ISO_8601, true).isValid()
        ? moment(openingTime).format("YYYY-MM-DD")
        : moment(new Date(openingTime)).format("YYYY-MM-DD");

      let query = { payment_method: "cash", date: formattedDate, petty_cash_uuid: uuid };

      if (routeName === "retur.index") {
        query.returType = type;
        delete query.date;
        delete query.payment_method;
      }

      const routeParams = {
        name: routeName,
        query,
      };
      const routePath = this.$router.resolve(routeParams).href;
      window.open(routePath, "_blank");
    },

    goToSellingDetail() {
      this.navigateWithCashAndDate("transaction.index");
    },
    
    goToStockLocationSku() {
      this.navigateWithCashAndDate("stock.gudang");
    },

    goToStockSupplier() {
      this.navigateWithCashAndDate("stock.supplier");
    },
    goToReturSelling(type) {
      this.navigateWithCashAndDate("retur.index", type);
    }
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/variables/_variables.scss";

.modal-content {
  border-radius: 16px;

  .modal-header {
    background-color: #fff !important;
    border-bottom: 1px solid #eee !important;
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;

    .modal-title {
      margin-left: 0 !important;
      margin-right: 0 !important;
    }
  }

  .modal-body {
    padding: 0;
  }
}

.button__group {
  display: flex;
  width: 100%;

  .button__cancel {
    background-color: #ffffff !important;
    border-color: #fff !important;
    color: $dark !important;
    box-shadow: 0px -2px 8px rgba(0, 0, 0, 0.04);
    border-radius: 0px 0px 0px 16px;
    width: 100%;
    height: 72px;
    font-size: 16px;
    font-weight: 800;
  }

  .button__save {
    background-color: #45b6ab !important;
    border-color: #45b6ab !important;
    box-shadow: 0px -2px 8px rgba(0, 0, 0, 0.04);
    border-radius: 0px 0px 16px 0px;
    width: 100%;
    height: 72px;
    font-size: 16px;
    font-weight: 800;
  }
}
</style>
